import FlashSaleProductCard from '../home/FlashSaleProductCard.vue';

export default {
    props: [
        'initialId',
        'initialFrom',
        'initialTo',
        'initialUntil',
        'initialMessage',
        'type',
        'url',
        'link',
    ],
    components: { FlashSaleProductCard },
    data() {
        return {
            fetchingProducts: false,
            id: this.initialId,
            products: [],
            count: 0,
            ajaxUrl: this.url,
            from: this.initialFrom,
            to: this.initialTo,
            message: this.initialMessage,
            until: this.initialUntil,
            categories: [],
            categoryId: 'all',
        };
    },
    mounted() {
        this.fetchProducts();

        if (this.type == 'campaign') {
            window.history.pushState({}, '', this.link + '/' + this.id);
        }

        if (this.until) {
            const time = this.until.split(':');
            const now = new Date();
            now.setHours(time[0], time[1], 0);
    
            $(this.$el).find('.deals-countdown').countdown({
                until: now,
                format: 'HMS',
                compact: true,
            });
        }
    },
    methods: {
        changeCampaign(id) {
            this.id = id;
            this.fetchProducts();
            window.history.pushState({}, '', this.link + '/' + id);
        },

        changeTime(from, to) {
            this.from = from;
            this.to = to;
            if (from != this.initialFrom && to != this.initialTo) {
                this.until = this.from;
                this.message = this.$trans('ecommerce::flash_sale.start_after');
            } else {
                this.message = this.initialMessage;
                this.until = this.initialUntil;
            }

            const time = this.until.split(':');
            const now = new Date();
            now.setHours(time[0], time[1], 0);

            $(this.$el).find('.deals-countdown').countdown('option', {
                until: now,
                format: 'HMS',
                compact: true,
            });

            this.fetchProducts();
        },

        changeCategory(id = null) {
            this.categoryId = id;
            this.fetchProducts();
        },

        fetchProducts() {
            this.fetchingProducts = true;

            if (this.type == 'campaign') {
                this.ajaxUrl = this.url + '?id=' + this.id;
            } else {
                this.ajaxUrl = this.url + '?from=' + this.from + '&to=' + this.to + '&categoryId=' + this.categoryId;
            }

            $.ajax({
                url: this.ajaxUrl,
            }).then((response) => {
                this.products = response.products;
                this.categories = response.categories;
                this.count = response.count;
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.fetchingProducts = false;
            });
        },

        more() {
            $.ajax({
                method: 'GET',
                url: this.ajaxUrl + '&skip=' + this.products.length,
            }).then((res) => {
                this.products = this.products.concat(res['products']);
            });
        },
    },
};